import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Select, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  select: {
    width: '100%',
    '& .MuiSelect-select': {
      padding: theme.spacing(1, 2),
      fontSize: 'var(--font-size-sm)'
    }
  }
}))

const SingleSelectEditor = forwardRef(({ value, onChange, onBlur, disabled, options = [] }, ref) => {
  const classes = useStyles()

  return (
    <Select
      ref={ref}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      className={classes.select}
      variant='outlined'
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
})

SingleSelectEditor.displayName = 'SingleSelectEditor'

SingleSelectEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))
}

export default SingleSelectEditor
